<div class="skeletor-list">
  <ul class="m-0 p-0 list-none">
    <li *ngFor="let i of rows" class="flex skeletor-list-item mb-4">
      <p-skeleton shape="circle" size="3rem" class="mr-2" />
      <div class="self-center" style="flex: 1">
        <p-skeleton width="70%" class="mb-4" />
        <p-skeleton width="40%" class="mb-2" />
      </div>
    </li>
  </ul>
</div>

